import React from 'react';
import Home from './components/Home';
// import Footer from './components/Footer';
import Header from './components/Header';
import { Container } from 'react-bootstrap';
import Transaction from './components/Transaction';
import Admin from './components/Admin';
import Login from './components/Login';
import Notfound from './components/notFound';
import Settings from './components/Settings';
import { Switch, Route, withRouter } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { AuthContext } from './context/auth';
import { UserProvider } from './context/ThemeContext';
import SettingContextProvider from './context/SettingContext';
import ErrorBoundary from './components/ErrorBoundary';

function debounce(fn, ms) {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

export const App = () => {

  const [authTokens, setAuthTokens] = React.useState(localStorage.getItem('tokens') || '');
  const [showHeaderOptions, setShowHeaderOptions] = React.useState(authTokens !== '' ? true : false);

  const setTokens = (data) => {
    // localStorage.setItem("tokens", data);
    // console.log("authTokenSet")
    if (!localStorage.language) {
      localStorage.setItem('language', 'English');
    }
    if (!localStorage.currency) {
      localStorage.setItem('currency', 'Euro');
    }
    if (!localStorage.operatorId) {
      localStorage.setItem('operatorId', '');
    }
    setAuthTokens(data);
    setShowHeaderOptions(true);
  };

  const logOut = () => {
    localStorage.removeItem('terminals');
    localStorage.removeItem('tokens');
    localStorage.removeItem('frequentTerminal');
    localStorage.removeItem('operatorId');

    // localStorage.setItem("tokens", '');
    // localStorage.setItem("language", '');
    setAuthTokens('');
    setShowHeaderOptions(false);
    window.location.reload(false);
  };

  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
    isMobile: window.innerWidth <= 520
  });

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
        isMobile: window.innerWidth <= 520
      });
    }, 500);
    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  });

  return (
    <ErrorBoundary logout={logOut}>
      <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>
        <UserProvider value={{ dimensions }}>
          <SettingContextProvider>
            <Container fluid>
              <Header showOptions={showHeaderOptions} ScreenWidth={dimensions.width} logout={logOut} isMobile={dimensions.isMobile} />

              <Switch>
                <Route path="/login" component={Login} />
                <PrivateRoute path="/config" component={Settings} />
                <PrivateRoute exact path="/" component={Home} />
                <PrivateRoute path="/transaction" component={Transaction} />
                <PrivateRoute path="/admin" component={Admin} />
                <Route component={Notfound} />
              </Switch>

              {/* <Footer /> */}
            </Container>
          </SettingContextProvider>
        </UserProvider>
      </AuthContext.Provider>
    </ErrorBoundary>
  );
};

export default withRouter(App);